import React, { useEffect, useState } from "react";
import { Button, Checkbox, Collapse, message } from "antd";
import Bankruptcy from "./Bankruptcy/Bankruptcy";
import TaxWarrantLiens from "./TaxWarrantLiens/TaxWarrantLiens";
import UCCFiling from "./UCCFilings/UCCFilings";
import LiensAsCreditor from "../NotableCourtRecords/LiensAsCreditor/LiensAsCreditor";
import LiensAsDebtor from "../NotableCourtRecords/LiensAsDebtor/LiensAsDebtor";
import JudgmentsAsDebtor from "../NotableCourtRecords/JudgmentsAsDebtor/JudgmentsAsDebtor";
import JudgmentsAsCreditor from "../NotableCourtRecords/JudgmentsAsCreditor/JudgmentsAsCreditor";
import {
  getApplicationNoRecords,
  updateApplicationNoRecords,
} from "../../../../services/adminForm.services";
import { useQuery } from "../../../../helpers/utility";

const { Panel } = Collapse;

const TWLFB = (props) => {
  const query = useQuery();
  const applicationId = query.get("id");
  const [appNoRcd, setAppNoRcdData] = useState(null);
  const [checkBox, setCheckBox] = useState({
    no_twl_records: appNoRcd?.no_twl_records,
    no_ucc_records: appNoRcd?.no_ucc_records,
    no_bankruptcy_records: appNoRcd?.no_bankruptcy_records,
    no_lc_records: appNoRcd?.no_lc_records,
    no_ld_records: appNoRcd?.no_ld_records,
    no_jd_records: appNoRcd?.no_jd_records,
    no_jc_records: appNoRcd?.no_jc_records,
  });
  const [checked, setChecked] = useState({
    key: [],
  });
  useEffect(() => {
    getApplicationNoRecordsApi();
  }, [applicationId]);

  async function getApplicationNoRecordsApi() {
    try {
      const res = await getApplicationNoRecords(applicationId);
      setAppNoRcdData(res?.data?.data);
    } catch (err) {
      console.log(err);
    }
  }

  async function updateApplicationApi(values) {
    try {
      const res = await updateApplicationNoRecords(applicationId, {
        no_twl_records: values?.no_twl_records,
        no_ucc_records: values?.no_ucc_records,
        no_bankruptcy_records: values?.no_bankruptcy_records,
        no_lc_records: values?.no_lc_records,
        no_ld_records: values?.no_ld_records,
        no_jd_records: values?.no_jd_records,
        no_jc_records: values?.no_jc_records,
      });
      message.success(res.data?.message);
    } catch (err) {
      console.log(err);
    } finally {
      getApplicationNoRecordsApi();
    }
  }

  return (
    <>
    <Collapse
      activeKey={
        checkBox?.no_twl_records
          ? checked?.key
          : ["1", "2", "3", "4", "5", "6", "7"]
      }
      onChange={(e) => {
        setChecked({ key: e });
      }}
    >
      <Panel
        header="Tax Warrant Liens"
        key="1"
        extra={
          <Checkbox
            checked={appNoRcd?.no_twl_records}
            onChange={(e) => {
              setCheckBox({
                ...checkBox,
                no_twl_records: e.target.checked,
              });
              updateApplicationApi({ no_twl_records: e.target.checked });
            }}
          >
            No Information Identified
          </Checkbox>
        }
        collapsible={appNoRcd?.no_twl_records ? "disabled" : ""}
      >
        <div
          style={
            appNoRcd?.no_twl_records
              ? {
                  cursor: "not-allowed",
                }
              : {}
          }
        >
          <TaxWarrantLiens disable={appNoRcd?.no_twl_records} />
        </div>
      </Panel>
      <Panel
        header="UCC Filing"
        key="2"
        extra={
          <Checkbox
            checked={appNoRcd?.no_ucc_records}
            onChange={(e) => {
              setCheckBox({ ...checkBox, no_ucc_records: e.target.checked });
              updateApplicationApi({ no_ucc_records: e.target.checked });
            }}
          >
            No Information Identified
          </Checkbox>
        }
        collapsible={appNoRcd?.no_ucc_records ? "disabled" : ""}
      >
        <div
          style={
            appNoRcd?.no_ucc_records
              ? {
                  cursor: "not-allowed",
                }
              : {}
          }
        >
          <UCCFiling disable={appNoRcd?.no_ucc_records} />
        </div>
      </Panel>
      <Panel
        header="Bankruptcy"
        key="3"
        extra={
          <Checkbox
            checked={appNoRcd?.no_bankruptcy_records}
            onChange={(e) => {
              setCheckBox({
                ...checkBox,
                no_bankruptcy_records: e.target.checked,
              });
              updateApplicationApi({ no_bankruptcy_records: e.target.checked });
            }}
          >
            No Information Identified
          </Checkbox>
        }
        collapsible={appNoRcd?.no_bankruptcy_records && "disabled"}
      >
        <div
          style={
            appNoRcd?.no_bankruptcy_records && checked?.key?.includes("3")
              ? {
                  cursor: "not-allowed",
                }
              : {}
          }
        >
          <Bankruptcy disable={appNoRcd?.no_bankruptcy_records} />
        </div>
      </Panel>
      <Panel
        header="Liens Filed Against Entity As Creditor"
        key="4"
        extra={
          <Checkbox
            checked={appNoRcd?.no_lc_records}
            onChange={(e) => {
              setCheckBox({
                ...checkBox,
                no_lc_records: e.target.checked,
              });
              updateApplicationApi({ no_lc_records: e.target.checked });
            }}
          >
            No Information Identified
          </Checkbox>
        }
        collapsible={appNoRcd?.no_lc_records ? "disabled" : ""}
      >
        <div
          style={
            appNoRcd?.no_lc_records
              ? {
                  cursor: "not-allowed",
                }
              : {}
          }
        >
          <LiensAsCreditor disable={appNoRcd?.no_lc_records} />
        </div>
      </Panel>

      <Panel
        header="Liens Filed Against Entity As Debtor"
        key="5"
        extra={
          <Checkbox
            checked={appNoRcd?.no_ld_records}
            onChange={(e) => {
              setCheckBox({
                ...checkBox,
                no_ld_records: e.target.checked,
              });
              updateApplicationApi({ no_ld_records: e.target.checked });
            }}
          >
            No Information Identified
          </Checkbox>
        }
        collapsible={appNoRcd?.no_ld_records ? "disabled" : ""}
      >
        <div
          style={
            appNoRcd?.no_ld_records
              ? {
                  cursor: "not-allowed",
                }
              : {}
          }
        >
          <LiensAsDebtor disable={appNoRcd?.no_ld_records} />
        </div>
      </Panel>

      <Panel
        header="Judgments Filed Against Entity As Debtor"
        key="6"
        extra={
          <Checkbox
            checked={appNoRcd?.no_jd_records}
            onChange={(e) => {
              setCheckBox({
                ...checkBox,
                no_jd_records: e.target.checked,
              });
              updateApplicationApi({ no_jd_records: e.target.checked });
            }}
          >
            No Information Identified
          </Checkbox>
        }
        collapsible={appNoRcd?.no_jd_records ? "disabled" : ""}
      >
        <div
          style={
            appNoRcd?.no_jd_records
              ? {
                  cursor: "not-allowed",
                }
              : {}
          }
        >
          <JudgmentsAsDebtor disable={appNoRcd?.no_jd_records} />
        </div>
      </Panel>

      <Panel
        header="Judgments Filed Against Entity As Creditor"
        key="7"
        extra={
          <Checkbox
            checked={appNoRcd?.no_jc_records}
            onChange={(e) => {
              setCheckBox({
                ...checkBox,
                no_jc_records: e.target.checked,
              });
              updateApplicationApi({ no_jc_records: e.target.checked });
            }}
          >
            No Information Identified
          </Checkbox>
        }
        collapsible={appNoRcd?.no_jc_records ? "disabled" : ""}
      >
        <div
          style={
            appNoRcd?.no_jc_records
              ? {
                  cursor: "not-allowed",
                }
              : {}
          }
        >
          <JudgmentsAsCreditor disable={appNoRcd?.no_jc_records} />
        </div>
      </Panel>
    </Collapse>
    <div style={{ marginTop: 16 }}>
      <Button
        type="primary"
        size="large"
        onClick={() => props.onStepChange?.(props.currentStep + 1)}
      >
        Save & Continue to next section
      </Button>
    </div>
    </>
  );
};

export default TWLFB;
